import { combineEpics } from "redux-observable";
import { epicFortuneTellerCollectReward } from "./epics/epicFortuneTellerCollectReward";
import { epicFortuneTellerEventBuyPackage } from "./epics/epicFortuneTellerEventBuyPackage";
import { epicFortuneTellerEventBuyPackageRequest } from "./epics/epicFortuneTellerEventBuyPackageRequest";
import { epicFortuneTellerEventInfo } from "./epics/epicFortuneTellerEventInfo";
export var epicFortuneTellerEvent = combineEpics(epicFortuneTellerEventInfo, epicFortuneTellerEventBuyPackage, epicFortuneTellerEventBuyPackageRequest, epicFortuneTellerCollectReward);



//////////////////
// WEBPACK FOOTER
// ./src/features/fortune-teller-event/epicFortuneTellerEvent.ts
// module id = 1854
// module chunks = 3